module.exports = __webpack_public_path__ + "static/media/autokar (1).e9b67c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (1).jpg
// module id = 427
// module chunks = 0